import Slider, {Settings} from "react-slick";
import MessageVariantOne from "../../components/consumer-messaging/variant-one";

import bitsatLogo from "../../assets/images/consumer-messaging/bitsat-logo.svg";
import jeeAdvLogo from "../../assets/images/consumer-messaging/jee-advance-logo.svg";
import "./assets/styles.css";

export default function Carousel() {
  const settings: Settings = {
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    pauseOnHover: true,
    fade: true,
    waitForAnimate: false,
    speed: 1000,
  };
  return (
    <Slider {...settings}>
      <MessageVariantOne
        title="Grind for BITSAT"
        subtitle={
          "Only a month left for BITSAT!\nPractice & Revise for the exam"
        }
        image={{
          url: bitsatLogo,
          alt: "BITSAT Logo",
          styles: {
            transform: "rotate(10deg) scale(1.2) translate(-17.5px, 15px)",
          },
        }}
        onClick={() => {}}
      />
      <MessageVariantOne
        title="JEE Advanced is here"
        subtitle={
          "Only a month left for the exam!\nPractice & Revise for the exam"
        }
        image={{
          url: jeeAdvLogo,
          alt: "JEE Advanced Logo",
          styles: {
            transform: "rotate(7.5deg) scale(1.25) translate(-15px, 0px)",
          },
        }}
        onClick={() => {}}
      />
    </Slider>
  );
}
